import React from 'react';
import { Select } from 'antd';
import { useQuery } from 'react-query';

import { getTaskListByProccode } from 'services/workflow';

export type TaskInputProps = {
  proccode?: string;
};

const TaskInput = ({ proccode, ...otherProps }: TaskInputProps) => {
  const { data } = useQuery(
    [proccode, 'getTaskListByProccode'],
    () =>
      getTaskListByProccode({ proccode: proccode! }).then(
        (res) => res.list || []
      ),
    {
      staleTime: 60 * 1000,
    }
  );

  return (
    <Select {...otherProps} allowClear>
      {data?.map(({ taskid, tasklabel }: any) => (
        <Select.Option value={taskid} key={taskid}>
          {tasklabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TaskInput;
